export const getOfferAppliedAmount = () => sessionStorage.getItem('offerNudgeAmount');
export const setOfferAppliedAmount = (amount: number) => sessionStorage.setItem('offerNudgeAmount', amount.toString());
export const removeOfferAppliedAmount = () => sessionStorage.removeItem('offerNudgeAmount');

const COUPON_CODE_KEY = 'couponCode';

export const getAppliedCoupons = (): string[] => {
  try {
    const stored = localStorage.getItem(COUPON_CODE_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : parsed ? [parsed] : [];
  } catch {
    return [];
  }
};

export const getOfferAppliedMessage = (
  appliedCoupons: string[],
  appliedText: string
): string => {
  if (!appliedCoupons.length) return '';

  return `${appliedCoupons.join(', ')} ${appliedText}`;
};

export const addAppliedCoupon = (couponCode: string) => {
  const coupons = getAppliedCoupons();
  if (!coupons.includes(couponCode)) {
    coupons.push(couponCode);
  }
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify(coupons));
};

export const removeAppliedCoupon = (couponCode: string) => {
  const coupons = getAppliedCoupons().filter((c) => c !== couponCode);
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify(coupons));
};

export const replaceAppliedCoupons = (couponCodes: string[]) => {
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify(couponCodes));
};

export const clearAppliedCoupons = () => {
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify([]));
};